"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.delete.confirm': 'Elimina Tutorial',
    'tutorial.delete.confirmText': 'Sei sicuro di voler eliminare questo tutorial? Questa azione non può essere annullata.',
    'tutorial.delete.success': 'Tutorial eliminato con successo',
};
